import { render, staticRenderFns } from "./ProfessionalizingPracticeUpdate.vue?vue&type=template&id=57342466"
import script from "./ProfessionalizingPracticeUpdate.vue?vue&type=script&lang=js"
export * from "./ProfessionalizingPracticeUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports